<script setup lang="ts">
import type { TableHTMLAttributes } from "vue";
import type { ClassProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";

interface Props extends ClassProps, /* @vue-ignore */ TableHTMLAttributes {}

const props = defineProps<Props>();
</script>

<template>
	<div class="relative overflow-x-auto">
		<table :class="cn('table w-full', props.class)" v-bind="$attrs">
			<slot />
		</table>
	</div>
</template>
